import React, { Fragment } from "react";
import CenterScreen from "../../../components/wrappers/CenterScreen";
import { Alert, Button, Divider, Paper, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { useForm } from "react-hook-form";
import AuthFooter from "../login/component/AuthFooter";
import { LOGIN } from "../../../enums/UrlPaths";
import { DELETE_ACCOUNT_CONFIRMATION, DELETE_ACCOUNT_REQUEST } from "../../../enums/ApiPaths";
import api from "../../../utils/api/authApi";
import { getTokenFromUrl } from "../../../utils/Functions";
import { HttpStatusCode } from "axios";

export default function DeleteAccountConfirmationPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [showGoBackButton, setShowGoBackButton] = React.useState(false);
  const { register, handleSubmit } = useForm();

  async function submitRequest(data) {
    const token = getTokenFromUrl();
    if (!token) {
      handleSnackbar("TokenMissing", "error");
      return; 
    }

    try {
      const res = await api.post(
        `${DELETE_ACCOUNT_CONFIRMATION}?token=${token}&reason=${data.reason}`
      );
      if (res.status === HttpStatusCode.Ok) {
        setShowGoBackButton(true);
        handleSnackbar("ActionCompletedSuccessfully", "success");
      }
    } catch (error) {
      setShowGoBackButton(true);
      handleSnackbar(error?.response?.data, "error");
    }
  }

  return (
    <Fragment>
      <CenterScreen minHeight="78vh">
        <Paper sx={{ p: { xs: 2, md: 4 }, width: "100%", maxWidth: 480 }}>
          <form onSubmit={handleSubmit(submitRequest)}>
            <Stack spacing={3}>
              <Typography variant="h5" fontWeight="bold">
                {t("DeleteUserTitleConfirm")}
              </Typography>
              <Divider />
              <Alert severity="warning">
                {t("AccountDeletionConfirmationMessage")}
              </Alert>
              <TextField
                fullWidth
                multiline
                minRows={4}
                maxRows={10}
                inputProps={{ maxLength: 255 }}
                label={`${t("Explanation")} (${t("Optional")})`}
                {...register("reason")}
              />
              <Stack spacing={1}>
                <Button type="submit" variant="contained" color="primary" fullWidth>
                  {t("Send")}
                </Button>
                <Button
                  onClick={() => navigate(LOGIN)}
                  variant={showGoBackButton ? "contained" : "outlined"}
                  color="primary"
                  fullWidth
                >
                  {t("GoBack")}
                </Button>
              </Stack>
            </Stack>
          </form>
        </Paper>
      </CenterScreen>
      <AuthFooter />
    </Fragment>
  );
}
